import React from 'react';
import PinwheelModal from '@pinwheel/react-modal';

function PinwheelModalWrapper({ isOpen, linkToken, setIsOpen, onSuccess, reauth, onContinue, onError }) {
    const successDataRef = React.useRef(null);

    React.useEffect(() => {
        if (isOpen) {
            successDataRef.current = null;
        }
    }, [isOpen]);

    React.useEffect(() => {
        const originalConsoleWarn = console.warn;
        console.warn = function (...args) {
            const message = args.join(' ');
            if (message.includes('Form submission canceled because the form is not connected')) {
                return;
            }
            originalConsoleWarn.apply(console, args);
        };
        return () => {
            console.warn = originalConsoleWarn;
        };
    }, []);

    return (
        <PinwheelModal
            linkToken={linkToken}
            open={isOpen}
            onError={typeof onError === 'function' ? (error) => onError(error) : undefined}
            onEvent={async (event, data) => {
                try {
                    if (event === 'success') {
                        successDataRef.current = {
                            accountId: data?.accountId,
                            platformId: data?.platformId,
                        };
                    }

                    if (event === 'exit') {
                        if (successDataRef.current) {
                            const { accountId, platformId } = successDataRef.current;
                            await onSuccess?.(accountId, platformId, reauth);
                        }
                        setIsOpen(false);
                        if (typeof onContinue === 'function') {
                            onContinue();
                        }
                    }

                    if (event === 'error') {
                        if (typeof onError === 'function') {
                            onError(data?.error || data, data);
                        } else {
                            console.error('Pinwheel error:', data);
                        }
                    }
                } catch (error) {
                    console.error('Pinwheel event handler error:', error);
                    if (typeof onError === 'function') {
                        onError(error);
                    }
                }
            }}
        />
    );
}

export default PinwheelModalWrapper;
